import { render, staticRenderFns } from "./V2SidePanel.vue?vue&type=template&id=616ebe7b&"
import script from "./V2SidePanel.vue?vue&type=script&lang=js&"
export * from "./V2SidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports